import { t } from '@procumi/shared';
import type { ReactNode } from 'react';
import { I, PATHS, type Tone } from './shared';

/**
 * Puntea: drumul unei achiziții, de la echipă la furnizori și înapoi la
 * comandă, cu câte lucruri stau acum în fiecare loc și pasul următor.
 * Arată ca restul cardurilor: plăcuțe colorate, cifre mari, butoanele aplicației.
 */
export interface BridgeStage {
  key: string;
  icon: keyof typeof PATHS;
  tone: Tone;
  label: string;
  value: ReactNode;
  note: ReactNode;
  /** ceva întârzie aici */
  alert?: boolean;
  cta?: { label: string; run: () => void };
  open?: () => void;
}

export function Bridge({ stages }: { stages: BridgeStage[] }) {
  return (
    <section className="db-card br" aria-label={t('Unde sunt achizițiile acum')}>
      <ol className="br-l">
        {stages.map((s) => (
          <li key={s.key} className={`br-s${s.alert ? ' alert' : ''}`}>
            <button type="button" className="br-m" onClick={s.open} disabled={!s.open}>
              <span className="br-k">
                <span className={`db-ico ${s.tone}`}>
                  <I d={s.icon} size={16} />
                </span>
                {s.label}
              </span>
              <b className="br-v">{s.value}</b>
              <span className="br-n">{s.note}</span>
            </button>
            {s.cta ? (
              <button
                type="button"
                className={`btn small${s.key === 'decide' ? ' primary' : ''} br-cta`}
                onClick={s.cta.run}
              >
                {s.cta.label}
              </button>
            ) : null}
          </li>
        ))}
      </ol>
    </section>
  );
}
